<template>
  <Layout>
    <div class="section content is-size-7">
      <p>
        Haben Sie Fragen zu Ihrem Abo? Wir stehen Ihnen gerne zur Verfügung und kümmern uns um Ihr anliegen.<br>
        Telefon: <a href="tel:0800100299">0800100299</a><br>
        E-Mail: <a href="mailto:businessfleet.at@silverlines.info">businessfleet.at@silverlines.info</a>
      </p>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'

export default {
  name: 'Help',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangKyf/AT/Help.vue